import React, { useEffect, useState } from "react";
import { Img, Wrap } from "./Styles";

interface BannerProps {
  imgUrl?: string;
}

export const Banner = ({ imgUrl }: BannerProps) => {
  const [ratio, setRatio] = useState(2);

  useEffect(() => {
    if (!imgUrl) return;
    const im = new Image();
    im.onload = () => {
      if (im.height > 0) setRatio(im.width / im.height);
    };
    im.src = imgUrl;
  }, [imgUrl]);

  if (!imgUrl) return null;

  return (
    <Wrap>
      <Img src={imgUrl} alt="" style={{ aspectRatio: ratio }} />
    </Wrap>
  );
};
